import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { Box, Tab } from "@mui/material";
import { useState } from "react";
import Card from "../../components/common/Card";
import Salons from "./Salons";
import SalonMap from "./SalonMap";

const ManagerSalon = () => {
  const [value, setValue] = useState("1");
  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };
  return (
    <Card>
      <TabContext value={value}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <TabList
            onChange={handleChange}
            aria-label="lab API tabs example"
            TabIndicatorProps={{ sx: { backgroundColor: "#ba2156" } }}
            sx={{ "& .MuiTab-root.Mui-selected": { color: "#ba2156" } }}
          >
            <Tab label="Shop List" value="1" sx={{textTransform: "capitalize"}}/>
            <Tab label="Registration" value="2" sx={{textTransform: "capitalize"}}/>
            <Tab label="Map" value="3" sx={{textTransform: "capitalize"}}/>
          </TabList>
        </Box>
        <TabPanel value="1"><Salons type="salon"></Salons></TabPanel>
        <TabPanel value="2"><Salons type="registration"></Salons></TabPanel>
        <TabPanel value="3"><SalonMap /></TabPanel>
      </TabContext>
    </Card>
  );
};
export default ManagerSalon;